export const DISPLAY_DESKTOPSUBMENU = true
